import { useState, type PropsWithChildren } from 'react'

import { Button } from '@ds/components'

import { COLLECTION_LABELS } from '../../constants/collectionStaticCopy'

import styles from './CollectionSuggestionsCollapse.module.css'

type TCollectionSuggestionsCollapseProps = PropsWithChildren

export const CollectionSuggestionsCollapse = ({
    children,
}: TCollectionSuggestionsCollapseProps) => {
    const [isFolded, setIsFolded] = useState(true)

    const handleToggle = () => setIsFolded(folded => !folded)

    return (
        <div className={styles.collapse}>
            <div data-folded={isFolded} className={styles.viewport}>
                {children}
            </div>
            <Button variant="secondary" size="small" onClick={handleToggle}>
                {isFolded ? COLLECTION_LABELS.showMore : COLLECTION_LABELS.showLess}
            </Button>
        </div>
    )
}
